export default __webpack_public_path__ + "static/18955-7403e2195a75bf544be0c84031342fc0.jpg";